import resume from '../assets/pdf/CV.pdf'
import image from '../assets/jpg/NewPhoto.jpg'

export const headerData = {
    name: 'Candy Velazco',
    title: "Computer Systems Engineer | UX/UI Designer",
    desciption:  "[📏] - Web Design\n" +
    "[👨🏻‍💻] - Web Apps Development\n" +
    "[💻] - UX/UI Design\n" +
    "[👨🏻‍💻] - Software Development",
    image: image,
    resumePdf: resume
}